// extracted by mini-css-extract-plugin
module.exports = {"PricingRangeDisplay":"PricingRangeDisplay_PricingRangeDisplay__1sj-2"};